import {createSelector} from 'reselect';

const getBoardingOptionsConfigFromShoppingCart = (store) => store.shoppingCart.boardingOptionsConfig || {};
const getProducts = (store) => store.productSelection.products || [];

const getInsurances = (products) => {
    const insurances = getProductByCategory(products, 'INSURANCE') || [];
    const fareRule = getProductByCategory(products, 'FARE_RULE') || [];
    return insurances.concat(fareRule);
};

const getServiceOptions = (products) => {
    return getProductByCategory(products, 'SERVICE_OPTION');
};

const getSeats = (products) => {
    return getProductByCategory(products, 'SEATS')[0] || [];
};

const getBoardingOptionsConfig = (boardingOptionsConfig) => boardingOptionsConfig || {};

const getProductBy = (by, products, title) => {
    return products.filter((product) => product.concept !== '' && title === product[by]);
};

const getProductByName = (products, productName) => {
    return getProductBy('name', products, productName);
};

const getProductByCategory = (products, productCategory) => {
    return getProductBy('category', products, productCategory);
};

const getBoardingOptions = (products) => {
    return getProductByName(products, 'BOARDING_OPTIONS')[0];
};

const getFastTrack = (products) => {
    return getProductByCategory(products, 'FAST_TRACK') || [];
};

const boardingOptionsSelector = createSelector(getProducts, getBoardingOptions);
const boardingOptionsConfigSelector = createSelector(getBoardingOptionsConfigFromShoppingCart, getBoardingOptionsConfig);
const insurancesSelector = createSelector(getProducts, getInsurances);
const serviceOptionsSelector = createSelector(getProducts, getServiceOptions);
const seatsSelector = createSelector(getProducts, getSeats);
const fastTrackSelector = createSelector(getProducts, getFastTrack);

export default {
    boardingOptionsSelection: (store) => boardingOptionsSelector(store),
    boardingOptionsConfig: (store) => boardingOptionsConfigSelector(store),
    seats: (store) => seatsSelector(store),
    serviceOptions: (store) => serviceOptionsSelector(store),
    insurances: (store) => insurancesSelector(store),
    fastTrack: (store) => fastTrackSelector(store),
};
